//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex';

import ButtonBlock from 'components/blocks/Button.vue'

export default {
  block: 'application',
  props: ['data'],
  components: {
    ButtonBlock,
  },
  data() {
    return {
      videoVisible: false,
      src: require("@/assets/imgs/"+this.data.img),
    }
  },
  methods: {
    openVideo() {
      this.videoVisible = true;
      // this.setBackDrop(true);
    },
    closeVideo() {
      this.videoVisible = false;
      // this.setBackDrop(false);
    },
    // ...mapMutations([
    //   'setBackDrop'
    // ])
  },
  watch: {
    videoVisible() {
      this.$emit('videoVisible', this.videoVisible);
    },
    hideVideo(){
      this.videoVisible = false;
    }
  }
}



// WEBPACK FOOTER //
// ./components/combinedBlocks/Application.vue